import { useState, useEffect } from 'react';
import { Calendar, User, ArrowRight, Image } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../config/api';
import './Blog.css';

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPosts();
    }, []);

    const fetchPosts = async () => {
        try {
            const response = await fetch(`${API_URL}/blog-posts`);
            const data = await response.json();
            if (data.success) setPosts(data.data || []);
        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    // Fallback static articles if DB is empty
    const defaultPosts = [
        {
            id: 1,
            slug: "que-es-la-genetica-clinica",
            title: "¿Qué es la genética clínica?",
            excerpt: "La genética clínica es la especialidad médica que se ocupa del diagnóstico de las condiciones genéticas...",
            published_at: "2024-03-10",
            author_name: "Dr. Alejandro Ruiz",
            cover_image_url: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&q=80&w=600"
        },
        {
            id: 2,
            slug: "cuando-acudir-a-consulta-genetica",
            title: "¿Cuándo acudir a consulta genética?",
            excerpt: "Existen señales clave que indican la necesidad de una valoración genética...",
            published_at: "2024-03-05",
            author_name: "Dra. Sofia Mendez",
            cover_image_url: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&q=80&w=600"
        },
        {
            id: 3,
            slug: "importancia-de-la-deteccion-temprana",
            title: "Importancia de la detección temprana",
            excerpt: "Identificar riesgos genéticos a tiempo puede cambiar el pronóstico de muchas enfermedades...",
            published_at: "2024-02-28",
            author_name: "Dr. Alejandro Ruiz",
            cover_image_url: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=600"
        }
    ];

    const displayPosts = posts.length > 0 ? posts : defaultPosts;

    if (loading) {
        return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando...</div>;
    }

    return (
        <div className="blog-page">
            <section className="page-header">
                <div className="container">
                    <h1 className="page-title">Blog Educativo</h1>
                    <p className="page-subtitle">
                        Información confiable y actualizada sobre genética, salud y bienestar.
                    </p>
                </div>
            </section>

            <section className="section container">
                <div className="blog-grid">
                    {displayPosts.map((post) => (
                        <article key={post.id} className="blog-card">
                            <div className="blog-image-wrapper">
                                {post.cover_image_url ? (
                                    <img src={post.cover_image_url} alt={post.title} className="blog-image" />
                                ) : (
                                    <div className="blog-image-placeholder">
                                        <Image size={48} />
                                    </div>
                                )}
                                {post.is_featured && <span className="featured-badge">Destacado</span>}
                            </div>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <span className="blog-date">
                                        <Calendar size={14} /> {formatDate(post.published_at)}
                                    </span>
                                    {post.author_name && (
                                        <span className="blog-author">
                                            <User size={14} /> {post.author_name}
                                        </span>
                                    )}
                                </div>
                                <h2 className="blog-title">{post.title}</h2>
                                <p className="blog-excerpt">{post.excerpt}</p>
                                {post.category && (
                                    <span className="blog-category">{post.category}</span>
                                )}
                                <Link to={`/blog/${post.slug}`} className="read-more">
                                    Leer artículo <ArrowRight size={16} />
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Blog;

